var config = require("./config.global");

config.backend_domain = "https://2l63114t0d.execute-api.us-east-1.amazonaws.com/prod";
config.authentication_user_pool_id = "us-east-1_jr1kNHL7d";
config.authentication_client_id = "6e1u7fugejct2bagl3r7m4r1md";

module.exports = config;
